import Terminals from "./Terminals";

export default Terminals;
